import { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";

import { IAtendimentoRepasseCaso } from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import {
    formatterContratoCEF,
    MoneyReaisFieldMask,
} from "../../../../Validations/InputMasks";
import UnForm from "../../../Form";
import moment from "moment";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import {
    ListarVinculacaoController,
    ListarModalidadeController,
    ListarCatorioController,
} from "../../../../Controllers/Repasse/GestaoDadosRepasse/GestaoDadosRepasse";
import { IListarAtributosPorEtapaTipoCaso } from "../../../../Interfaces/Geral/AtributosEtapa/AtributosEtapaInterface";

interface IComponentNameProps {
    gestaoRepasseDados: IAtendimentoRepasseCaso;
    idTipoCaso?: number;
    idEtapaCategoriaAtendimento?: number;
    atributosPorEtapa: IListarAtributosPorEtapaTipoCaso[] | undefined;
}

export default function RepasseDados(props: IComponentNameProps) {
    const formMethods = useFormContext<IAtendimentoRepasseCaso>();
    localStorage.setItem("repasseDados", JSON.stringify(formMethods.watch()));

    function geradorMascaraFinanceira(
        inputName: keyof IAtendimentoRepasseCaso
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);

            formMethods.setValue(inputName, mask);
        };
    }

    function formatadorDatas(inputName: keyof IAtendimentoRepasseCaso) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            let data: string | string[] = e.target.value;

            if (data.length !== 10) {
                let nvDate: string | string[] = data.split("-");
                nvDate[0] = nvDate[0].substring(1, 5);
                nvDate = nvDate.join("-");
                data = nvDate;
            }

            formMethods.setValue(inputName, moment(data).format("YYYY-MM-DD"));
        };
    }

    const currentDate = moment().format("YYYY-MM-DD");

    return (
        <>
            <div className="d-flex row col-12 justify-content-between aling-item-center p-4">
                <div className="col-12 col-md-auto">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_A_CONFIRMAR"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Compra e Venda:"
                            name="VL_A_CONFIRMAR"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_A_CONFIRMAR"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_A_CONFIRMAR"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_A_CONFIRMAR &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_A_CONFIRMAR
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_A_CONFIRMAR"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_A_CONFIRMAR_MAX"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Máximo a Confirmar:"
                            name="VL_A_CONFIRMAR_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_A_CONFIRMAR_MAX"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_A_CONFIRMAR_MAX"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_A_CONFIRMAR &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_A_CONFIRMAR_MAX
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_A_CONFIRMAR_MAX"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VL_ORIGINAL"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Original:"
                            name="VL_ORIGINAL"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_ORIGINAL"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_ORIGINAL")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_ORIGINAL &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_ORIGINAL
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_ORIGINAL"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_FINANCIAMENTO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Financiamento"
                            name="VL_FINANCIAMENTO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FINANCIAMENTO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FINANCIAMENTO"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_FINANCIAMENTO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_FINANCIAMENTO
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FINANCIAMENTO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "VL_FINANCIAMENTO_CONFIRMADO_MAX"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Máximo Confirmado Financiamento"
                            name="VL_FINANCIAMENTO_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FINANCIAMENTO_CONFIRMADO_MAX"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FINANCIAMENTO_CONFIRMADO_MAX"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_FINANCIAMENTO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_FINANCIAMENTO_CONFIRMADO_MAX
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FINANCIAMENTO_CONFIRMADO_MAX"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VL_FGTS"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="FGTS"
                            name="VL_FGTS"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_FGTS"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_FGTS")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_FGTS &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_FGTS
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_FGTS"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "VL_FGTS_CONFIRMADO_MAX"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Máximo FGTS Confirmado"
                            name="VL_FGTS_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FGTS_CONFIRMADO_MAX"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_FGTS_CONFIRMADO_MAX"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.VL_FGTS_CONFIRMADO_MAX &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_FGTS_CONFIRMADO_MAX
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_FGTS_CONFIRMADO_MAX"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VL_SUBSIDIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Subsídio / Subvenção:"
                            name="VL_SUBSIDIO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_SUBSIDIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_SUBSIDIO")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_SUBSIDIO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_SUBSIDIO
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_SUBSIDIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "NR_RIP_SPU"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="N° RIP (SPU)"
                            name="NR_RIP_SPU"
                            defaultValue={props.gestaoRepasseDados.NR_RIP_SPU}
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_RIP_SPU"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_RIP_SPU"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DS_CATEGORIA_USO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Categoria de Uso"
                            name="DS_CATEGORIA_USO"
                            defaultValue={
                                props.gestaoRepasseDados.DS_CATEGORIA_USO
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DS_CATEGORIA_USO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DS_CATEGORIA_USO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "VL_SUBSIDIO_CONFIRMADO_MAX"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Máximo Subsídio / Subvenção:"
                            name="VL_SUBSIDIO_CONFIRMADO_MAX"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_SUBSIDIO_CONFIRMADO_MAX"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_SUBSIDIO_CONFIRMADO_MAX"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.VL_SUBSIDIO_CONFIRMADO_MAX &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_SUBSIDIO_CONFIRMADO_MAX
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_SUBSIDIO_CONFIRMADO_MAX"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_RECURSOS_PROPRIOS"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Recursos Próprios:"
                            name="VL_RECURSOS_PROPRIOS"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RECURSOS_PROPRIOS"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_RECURSOS_PROPRIOS"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.VL_RECURSOS_PROPRIOS &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_RECURSOS_PROPRIOS
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RECURSOS_PROPRIOS"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                </div>
                <div className="col-12 col-md-auto">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VL_ITBI"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="ITBI:"
                            name="VL_ITBI"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_ITBI"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_ITBI")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_ITBI &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_ITBI
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_ITBI"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_EMULENTOS"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Emolumentos"
                            name="VL_EMULENTOS"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_EMULENTOS"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_EMULENTOS")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_EMULENTOS &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_EMULENTOS
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_EMULENTOS"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VL_LAUDEMIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Laudêmio"
                            name="VL_LAUDEMIO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_LAUDEMIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira("VL_LAUDEMIO")}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_LAUDEMIO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados?.VL_LAUDEMIO
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "VL_LAUDEMIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_DESPESAS_REGISTRO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Outras Despesas"
                            name="VL_DESPESAS_REGISTRO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_DESPESAS_REGISTRO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_DESPESAS_REGISTRO"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.VL_DESPESAS_REGISTRO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_DESPESAS_REGISTRO
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_DESPESAS_REGISTRO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "VL_RENDA_PROPONENTE"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Valor Renda Proponente:"
                            name="VL_RENDA_PROPONENTE"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RENDA_PROPONENTE"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_RENDA_PROPONENTE"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados?.VL_RENDA_PROPONENTE &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_RENDA_PROPONENTE
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RENDA_PROPONENTE"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "VL_RENDA_FAMILIAR_HYPNO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Renda Familiar (Hypno):"
                            name="VL_RENDA_FAMILIAR_HYPNO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    if (v) {
                                        return Number(
                                            MoneyReaisFieldMask.unMask(v)
                                        );
                                    }
                                    return v;
                                },
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RENDA_FAMILIAR_HYPNO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_RENDA_FAMILIAR_HYPNO"
                            )}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.VL_RENDA_FAMILIAR_HYPNO &&
                                formatMoneyReais(
                                    props.gestaoRepasseDados
                                        ?.VL_RENDA_FAMILIAR_HYPNO
                                )
                            }
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "VL_RENDA_FAMILIAR_HYPNO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                </div>

                <div className="col-12 col-md-auto">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "VALORES"
                        ) || []
                    ).length > 0 && (
                        <>
                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_USUARIO_CCA"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        style={{ width: 187 }}
                                        label="CCA"
                                        name="ID_USUARIO_CCA"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_USUARIO_CCA
                                        }
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_USUARIO_CCA"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                        controller={ListarUsuariosController}
                                        getKeyValue={(u) => u.ID_USUARIO}
                                        getDS={(u) => u.DS_NOME}
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_USUARIO_CCA"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_AGENCIA_VINCULACAO"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        label="Agência"
                                        name="ID_AGENCIA_VINCULACAO"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_AGENCIA_VINCULACAO
                                        }
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_AGENCIA_VINCULACAO"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                        controller={ListarVinculacaoController}
                                        getKeyValue={(v) =>
                                            v.ID_AGENCIA_VINCULACAO
                                        }
                                        getDS={(v) => v.DS_AGENCIA_VINCULO}
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_AGENCIA_VINCULACAO"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_TIPO_MODALIDADE"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        label="Modalidade"
                                        name="ID_TIPO_MODALIDADE"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_TIPO_MODALIDADE
                                        }
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_TIPO_MODALIDADE"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                        controller={ListarModalidadeController}
                                        getKeyValue={(m) =>
                                            m.ID_TIPO_MODALIDADE
                                        }
                                        getDS={(m) => m.DS_TIPO_MODALIDADE}
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_TIPO_MODALIDADE"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_CONTRATO"
                                ) || []
                            ).length > 0 && (
                                <UnForm.Input
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="N° Contrato"
                                    name="NR_CONTRATO"
                                    defaultValue={
                                        props.gestaoRepasseDados.NR_CONTRATO
                                    }
                                    maxLength={16}
                                    onChange={(e) => formatterContratoCEF(e)}
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "NR_CONTRATO"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "NR_CONTRATO"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.Input>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_MATRICULA"
                                ) || []
                            ).length > 0 && (
                                <UnForm.Input
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="Matrícula"
                                    name="NR_MATRICULA"
                                    defaultValue={
                                        props.gestaoRepasseDados.NR_MATRICULA
                                    }
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "NR_MATRICULA"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "NR_MATRICULA"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.Input>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "ID_CARTORIO"
                                ) || []
                            ).length > 0 && (
                                <UnForm.LazySelect
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="Cartório"
                                    name="ID_CARTORIO"
                                    controller={ListarCatorioController}
                                    getDS={(c) => c.DS_CARTORIO}
                                    getKeyValue={(c) => c.ID_CARTORIO}
                                    defaultValue={
                                        props.gestaoRepasseDados.ID_CARTORIO
                                    }
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_CARTORIO"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "ID_CARTORIO"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.LazySelect>
                            )}
                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_PROTOCOLO"
                                ) || []
                            ).length > 0 && (
                                <UnForm.Input
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="N° Protocolo"
                                    name="NR_PROTOCOLO"
                                    defaultValue={
                                        props.gestaoRepasseDados.NR_PROTOCOLO
                                    }
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "NR_PROTOCOLO"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "NR_PROTOCOLO"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.Input>
                            )}
                        </>
                    )}
                </div>
            </div>

            <hr className="col-12" />
            <div className="d-flex row col-12 justify-content-between aling-item-center p-4">
                <div className="col-12 col-md-auto">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_EMISSAO_ERP"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Emissão RP"
                            name="DT_EMISSAO_ERP"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_ERP"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_EMISSAO_ERP"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_EMISSAO_ERP")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_EMISSAO_ERP
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_EMISSAO_ERP
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_ERP"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_ERP"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_ASSINATURA_ERP"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Assinatura RP"
                            name="DT_ASSINATURA_ERP"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_ERP"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ASSINATURA_ERP"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ASSINATURA_ERP")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_ASSINATURA_ERP
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ASSINATURA_ERP
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_ERP"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_ERP"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_VALIDADE_SICAQ"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Validade Sicaq"
                            name="DT_VALIDADE_SICAQ"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_VALIDADE_SICAQ"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_VALIDADE_SICAQ"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_VALIDADE_SICAQ")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_VALIDADE_SICAQ
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_VALIDADE_SICAQ
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_VALIDADE_SICAQ"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_VALIDADE_SICAQ"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_MINUTA_CAIXA"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Minuta CEF"
                            name="DT_MINUTA_CAIXA"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_MINUTA_CAIXA"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_MINUTA_CAIXA"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_MINUTA_CAIXA")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_MINUTA_CAIXA
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_MINUTA_CAIXA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_MINUTA_CAIXA"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_MINUTA_CAIXA"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_ASSINATURA_CAIXA"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Assinatura CEF"
                            name="DT_ASSINATURA_CAIXA"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_CAIXA"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ASSINATURA_CAIXA"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ASSINATURA_CAIXA")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_ASSINATURA_CAIXA
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ASSINATURA_CAIXA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_CAIXA"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ASSINATURA_CAIXA"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "DT_ENTRADA"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Disponível Agência"
                            name="DT_ENTRADA"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_ENTRADA"
                                )[0]?.FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ENTRADA"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ENTRADA")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_ENTRADA
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ENTRADA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_ENTRADA"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_ENTRADA"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_RECEBIMENTO_KIT"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Kit Registro"
                            name="DT_RECEBIMENTO_KIT"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_KIT"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    .DT_RECEBIMENTO_KIT_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_RECEBIMENTO_KIT_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_RECEBIMENTO_KIT_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_RECEBIMENTO_KIT"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_RECEBIMENTO_KIT")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_RECEBIMENTO_KIT
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_RECEBIMENTO_KIT
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_KIT"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_KIT"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                </div>

                <div className="col-12 col-md-auto">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_SOLICITACAO_ITBI"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Solicitação ITBI"
                            name="DT_SOLICITACAO_ITBI"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ITBI"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_SOLICITACAO_ITBI_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_SOLICITACAO_ITBI_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_SOLICITACAO_ITBI_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_SOLICITACAO_ITBI"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_SOLICITACAO_ITBI")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados?.DT_SOLICITACAO_ITBI
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_SOLICITACAO_ITBI
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ITBI"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ITBI"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_SOLICITACAO_ISENCAO_ITBI"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Solicitação Isenção"
                            name="DT_SOLICITACAO_ISENCAO_ITBI"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ISENCAO_ITBI"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_SOLICITACAO_ISENCAO_ITBI_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_SOLICITACAO_ISENCAO_ITBI_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_SOLICITACAO_ISENCAO_ITBI_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_SOLICITACAO_ISENCAO_ITBI"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_SOLICITACAO_ISENCAO_ITBI")(
                                    event
                                );
                            }}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.DT_SOLICITACAO_ISENCAO_ITBI
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_SOLICITACAO_ISENCAO_ITBI
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ISENCAO_ITBI"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_ISENCAO_ITBI"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_EMISSAO_GUIA_ITBI"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Emissão Guia ITBI"
                            name="DT_EMISSAO_GUIA_ITBI"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_GUIA_ITBI"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_EMISSAO_GUIA_ITBI_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_EMISSAO_GUIA_ITBI_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_EMISSAO_GUIA_ITBI_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_EMISSAO_GUIA_ITBI"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_EMISSAO_GUIA_ITBI")(event);
                            }}
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados?.DT_EMISSAO_GUIA_ITBI
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_EMISSAO_GUIA_ITBI
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_GUIA_ITBI"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSAO_GUIA_ITBI"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_SOLICITACAO_QUITACAO_ITBI"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Envio ITBI Financeiro"
                            name="DT_SOLICITACAO_QUITACAO_ITBI"
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_SOLICITACAO_QUITACAO_ITBI_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_SOLICITACAO_QUITACAO_ITBI_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_SOLICITACAO_QUITACAO_ITBI_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_SOLICITACAO_QUITACAO_ITBI"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_SOLICITACAO_QUITACAO_ITBI")(
                                    event
                                );
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_QUITACAO_ITBI"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.DT_SOLICITACAO_QUITACAO_ITBI
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_SOLICITACAO_QUITACAO_ITBI
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_QUITACAO_ITBI"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_QUITACAO_ITBI"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_PAGAMENTO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Data Pagamento"
                            name="DT_PAGAMENTO"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PAGAMENTO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados?.DT_PAGAMENTO_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_PAGAMENTO_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_PAGAMENTO_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_PAGAMENTO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_PAGAMENTO")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados?.DT_PAGAMENTO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_PAGAMENTO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            type="date"
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PAGAMENTO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PAGAMENTO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_RECEBIMENTO_COMPROVANTE"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Data Recebimento Comprovante"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_COMPROVANTE"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            name="DT_RECEBIMENTO_COMPROVANTE"
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_RECEBIMENTO_COMPROVANTE_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_RECEBIMENTO_COMPROVANTE_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_RECEBIMENTO_COMPROVANTE_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_RECEBIMENTO_COMPROVANTE"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_RECEBIMENTO_COMPROVANTE")(
                                    event
                                );
                            }}
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.DT_RECEBIMENTO_COMPROVANTE
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_RECEBIMENTO_COMPROVANTE
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_COMPROVANTE"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_COMPROVANTE"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_PREVISAO_CONFORMIDADE"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="TQ / CND ITBI"
                            name="DT_PREVISAO_CONFORMIDADE"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_CONFORMIDADE"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_PREVISAO_CONFORMIDADE"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_PREVISAO_CONFORMIDADE")(
                                    event
                                );
                            }}
                            type="date"
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_CONFORMIDADE"
                                )[0]?.FL_APENAS_LEITURA
                            }
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.DT_PREVISAO_CONFORMIDADE
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_PREVISAO_CONFORMIDADE
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_CONFORMIDADE"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_ORCAMENTO_CARTORIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Orçamento Cartório"
                            name="DT_ORCAMENTO_CARTORIO"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ORCAMENTO_CARTORIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ORCAMENTO_CARTORIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ORCAMENTO_CARTORIO")(event);
                            }}
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados?.DT_ORCAMENTO_CARTORIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ORCAMENTO_CARTORIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ORCAMENTO_CARTORIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ORCAMENTO_CARTORIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_ENVIO_PARA_FINANCEIRO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Envio Orç. Financeiro"
                            name="DT_ENVIO_PARA_FINANCEIRO"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_PARA_FINANCEIRO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ENVIO_PARA_FINANCEIRO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ENVIO_PARA_FINANCEIRO")(
                                    event
                                );
                            }}
                            defaultValue={
                                props.gestaoRepasseDados
                                    ?.DT_ENVIO_PARA_FINANCEIRO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ENVIO_PARA_FINANCEIRO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_PARA_FINANCEIRO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_PARA_FINANCEIRO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_PRENOTACAO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Prenotação"
                            name="DT_PRENOTACAO"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PRENOTACAO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type="date"
                            min={
                                props.gestaoRepasseDados?.DT_PRENOTACAO_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_PRENOTACAO_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_PRENOTACAO_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_PRENOTACAO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_PRENOTACAO")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados?.DT_PRENOTACAO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_PRENOTACAO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PRENOTACAO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_PRENOTACAO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_REGISTRO_CONFORME"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Registro"
                            name="DT_REGISTRO_CONFORME"
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_REGISTRO_CONFORME_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_REGISTRO_CONFORME"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_REGISTRO_CONFORME")(event);
                            }}
                            type="date"
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_REGISTRO_CONFORME_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_REGISTRO_CONFORME_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_REGISTRO_CONFORME"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados?.DT_REGISTRO_CONFORME
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_REGISTRO_CONFORME
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_REGISTRO_CONFORME"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_REGISTRO_CONFORME"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_LIBERACAO_CARTORIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Liberação Cartório"
                            name="DT_LIBERACAO_CARTORIO"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_LIBERACAO_CARTORIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_LIBERACAO_CARTORIO_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_LIBERACAO_CARTORIO_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_LIBERACAO_CARTORIO_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_LIBERACAO_CARTORIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_LIBERACAO_CARTORIO")(event);
                            }}
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados?.DT_LIBERACAO_CARTORIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_LIBERACAO_CARTORIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_LIBERACAO_CARTORIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_LIBERACAO_CARTORIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "DT_RETIRADA"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Retirada Cartório"
                            name="DT_RETIRADA"
                            min={
                                props.gestaoRepasseDados?.DT_RETIRADA_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_RETIRADA_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_RETIRADA_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_RETIRADA"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_RETIRADA")(event);
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_RETIRADA"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados?.DT_RETIRADA
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_RETIRADA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_RETIRADA"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_RETIRADA"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_PREVISAO_SAIDA"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Envio P/ Desbloqueio"
                            name="DT_PREVISAO_SAIDA"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_SAIDA"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            min={
                                props.gestaoRepasseDados
                                    ?.DT_PREVISAO_SAIDA_INICIAL
                                    ? moment(
                                          props.gestaoRepasseDados
                                              ?.DT_PREVISAO_SAIDA_INICIAL
                                      ).format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;
                                const initialDate =
                                    props.gestaoRepasseDados
                                        ?.DT_PREVISAO_SAIDA_INICIAL;

                                if (
                                    initialDate &&
                                    moment(selectedDate).isBefore(
                                        initialDate,
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment(initialDate).format(
                                            "YYYY-MM-DD"
                                        );
                                } else if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_PREVISAO_SAIDA"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    moment(selectedDate).isAfter(
                                        moment(),
                                        "day"
                                    )
                                ) {
                                    event.target.value =
                                        moment().format("YYYY-MM-DD");
                                }

                                formatadorDatas("DT_PREVISAO_SAIDA")(event);
                            }}
                            type="date"
                            defaultValue={
                                props.gestaoRepasseDados?.DT_PREVISAO_SAIDA
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_PREVISAO_SAIDA
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_SAIDA"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PREVISAO_SAIDA"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_ENVIO_CEHOP"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Envio P/ CEHOP"
                            name="DT_ENVIO_CEHOP"
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_CEHOP"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ENVIO_CEHOP"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ENVIO_CEHOP")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_ENVIO_CEHOP
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ENVIO_CEHOP
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_CEHOP"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_CEHOP"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_CONFORMIDADE_CEHOP"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Garantia Conforme"
                            name="DT_CONFORMIDADE_CEHOP"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_CONFORMIDADE_CEHOP"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_CONFORMIDADE_CEHOP"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_CONFORMIDADE_CEHOP")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_CONFORMIDADE_CEHOP
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_CONFORMIDADE_CEHOP
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_CONFORMIDADE_CEHOP"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_CONFORMIDADE_CEHOP"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_RECEBIMENTO_GARANTIA_CEHOP"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Recebimento Garantia CEHOP"
                            name="DT_RECEBIMENTO_GARANTIA_CEHOP"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_GARANTIA_CEHOP"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_RECEBIMENTO_GARANTIA_CEHOP"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas(
                                    "DT_RECEBIMENTO_GARANTIA_CEHOP"
                                )(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados
                                    .DT_RECEBIMENTO_GARANTIA_CEHOP
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_RECEBIMENTO_GARANTIA_CEHOP
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_GARANTIA_CEHOP"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_RECEBIMENTO_GARANTIA_CEHOP"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}

                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "DT_DISTRATO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Distrato"
                            name="DT_DISTRATO"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_DISTRATO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_DISTRATO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_DISTRATO")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados?.DT_DISTRATO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_DISTRATO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_DISTRATO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_DISTRATO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                </div>

                <div className="col-12 col-md-auto ">
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) => atributo.DS_ATRIBUTO === "DATAS"
                        ) || []
                    ).length > 0 && (
                        <>
                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_USUARIO_CCA"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        style={{ width: 187 }}
                                        label="CCA"
                                        name="ID_USUARIO_CCA"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_USUARIO_CCA
                                        }
                                        controller={ListarUsuariosController}
                                        getKeyValue={(u) => u.ID_USUARIO}
                                        getDS={(u) => u.DS_NOME}
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_USUARIO_CCA"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_USUARIO_CCA"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_AGENCIA_VINCULACAO"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        label="Agência"
                                        name="ID_AGENCIA_VINCULACAO"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_AGENCIA_VINCULACAO
                                        }
                                        controller={ListarVinculacaoController}
                                        getKeyValue={(v) =>
                                            v.ID_AGENCIA_VINCULACAO
                                        }
                                        getDS={(v) => v.DS_AGENCIA_VINCULO}
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_AGENCIA_VINCULACAO"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_AGENCIA_VINCULACAO"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "ID_TIPO_MODALIDADE"
                                ) || []
                            ).length > 0 && (
                                <div className="mr-20">
                                    <UnForm.LazySelect
                                        wrapperClassName="p-2 col-12 mb-3"
                                        className="mb-4"
                                        label="Modalidade"
                                        name="ID_TIPO_MODALIDADE"
                                        defaultValue={
                                            props.gestaoRepasseDados
                                                .ID_TIPO_MODALIDADE
                                        }
                                        controller={ListarModalidadeController}
                                        getKeyValue={(m) =>
                                            m.ID_TIPO_MODALIDADE
                                        }
                                        getDS={(m) => m.DS_TIPO_MODALIDADE}
                                        registerOptions={{
                                            required:
                                                props.atributosPorEtapa?.filter(
                                                    (atributo) =>
                                                        atributo.DS_ATRIBUTO ===
                                                        "ID_TIPO_MODALIDADE"
                                                )[0]?.FL_OBRIGATORIO,
                                        }}
                                        disabled={
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "ID_TIPO_MODALIDADE"
                                            )[0]?.FL_APENAS_LEITURA
                                        }
                                    ></UnForm.LazySelect>
                                </div>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_CONTRATO"
                                ) || []
                            ).length > 0 && (
                                <UnForm.Input
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="N° Contrato"
                                    name="NR_CONTRATO"
                                    defaultValue={
                                        props.gestaoRepasseDados.NR_CONTRATO
                                    }
                                    maxLength={16}
                                    onChange={(e) => formatterContratoCEF(e)}
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "NR_CONTRATO"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "NR_CONTRATO"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.Input>
                            )}

                            {(
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "NR_MATRICULA"
                                ) || []
                            ).length > 0 && (
                                <UnForm.Input
                                    wrapperClassName="p-2 col-12 mb-3"
                                    className="mb-4"
                                    label="Matrícula"
                                    name="NR_MATRICULA"
                                    defaultValue={
                                        props.gestaoRepasseDados.NR_MATRICULA
                                    }
                                    registerOptions={{
                                        required:
                                            props.atributosPorEtapa?.filter(
                                                (atributo) =>
                                                    atributo.DS_ATRIBUTO ===
                                                    "NR_MATRICULA"
                                            )[0]?.FL_OBRIGATORIO,
                                    }}
                                    disabled={
                                        props.atributosPorEtapa?.filter(
                                            (atributo) =>
                                                atributo.DS_ATRIBUTO ===
                                                "NR_MATRICULA"
                                        )[0]?.FL_APENAS_LEITURA
                                    }
                                ></UnForm.Input>
                            )}
                        </>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_SOLICITACAO_LAUDEMIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Solicitação Laudêmio"
                            name="DT_SOLICITACAO_LAUDEMIO"
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_SOLICITACAO_LAUDEMIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_SOLICITACAO_LAUDEMIO")(
                                    event
                                );
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_LAUDEMIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados.DT_SOLICITACAO_LAUDEMIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_SOLICITACAO_LAUDEMIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_LAUDEMIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_SOLICITACAO_LAUDEMIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_EMISSÂO_GUIA_LAUDEMIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Emissão Guia Laudêmio"
                            name="DT_EMISSÂO_GUIA_LAUDEMIO"
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_EMISSÂO_GUIA_LAUDEMIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_EMISSÂO_GUIA_LAUDEMIO")(
                                    event
                                );
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSÂO_GUIA_LAUDEMIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados
                                    .DT_EMISSÂO_GUIA_LAUDEMIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_EMISSÂO_GUIA_LAUDEMIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSÂO_GUIA_LAUDEMIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_EMISSÂO_GUIA_LAUDEMIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO ===
                                "DT_ENVIO_LAUDEMIO_FINANCEIRO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Envio Laudêmio Financeiro"
                            name="DT_ENVIO_LAUDEMIO_FINANCEIRO"
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_ENVIO_LAUDEMIO_FINANCEIRO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_ENVIO_LAUDEMIO_FINANCEIRO")(
                                    event
                                );
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_LAUDEMIO_FINANCEIRO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados
                                    .DT_ENVIO_LAUDEMIO_FINANCEIRO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_ENVIO_LAUDEMIO_FINANCEIRO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_LAUDEMIO_FINANCEIRO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_ENVIO_LAUDEMIO_FINANCEIRO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_NUM_RIP_SPU"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Data N° RIP (SPU)"
                            name="DT_NUM_RIP_SPU"
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_NUM_RIP_SPU"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_NUM_RIP_SPU")(event);
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_NUM_RIP_SPU"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados.DT_NUM_RIP_SPU
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_NUM_RIP_SPU
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_NUM_RIP_SPU"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_NUM_RIP_SPU"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_PAGAMENTO_LAUDEMIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Pagamento Laudêmio"
                            name="DT_PAGAMENTO_LAUDEMIO"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PAGAMENTO_LAUDEMIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_PAGAMENTO_LAUDEMIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_PAGAMENTO_LAUDEMIO")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_PAGAMENTO_LAUDEMIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_PAGAMENTO_LAUDEMIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PAGAMENTO_LAUDEMIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_PAGAMENTO_LAUDEMIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_COMPROV_LAUDEMIO"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="Comprovante Laudêmio"
                            name="DT_COMPROV_LAUDEMIO"
                            type={"date"}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_COMPROV_LAUDEMIO"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_COMPROV_LAUDEMIO"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_COMPROV_LAUDEMIO")(event);
                            }}
                            defaultValue={
                                props.gestaoRepasseDados.DT_COMPROV_LAUDEMIO
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_COMPROV_LAUDEMIO
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_COMPROV_LAUDEMIO"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO ===
                                        "DT_COMPROV_LAUDEMIO"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                    {(
                        props.atributosPorEtapa?.filter(
                            (atributo) =>
                                atributo.DS_ATRIBUTO === "DT_TQ_CAT_SPU"
                        ) || []
                    ).length > 0 && (
                        <UnForm.Input
                            wrapperClassName="p-2 col-12 mb-3"
                            className="mb-4"
                            label="TQ / CAT SPU"
                            name="DT_TQ_CAT_SPU"
                            type={"date"}
                            onChange={(event) => {
                                const selectedDate = event.target.value;

                                if (
                                    props.atributosPorEtapa?.filter(
                                        (atributo) =>
                                            atributo.DS_ATRIBUTO ===
                                            "DT_TQ_CAT_SPU"
                                    )[0]?.FL_NAO_PERMITE_DATA_FUTURA &&
                                    selectedDate > currentDate
                                ) {
                                    event.target.value = currentDate;
                                }

                                formatadorDatas("DT_TQ_CAT_SPU")(event);
                            }}
                            max={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_TQ_CAT_SPU"
                                )[0].FL_NAO_PERMITE_DATA_FUTURA
                                    ? moment().format("YYYY-MM-DD")
                                    : undefined
                            }
                            defaultValue={
                                props.gestaoRepasseDados.DT_TQ_CAT_SPU
                                    ? new Date(
                                          props.gestaoRepasseDados.DT_TQ_CAT_SPU
                                      )
                                          .toISOString()
                                          .substring(0, 10)
                                    : undefined
                            }
                            registerOptions={{
                                required: props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_TQ_CAT_SPU"
                                )[0]?.FL_OBRIGATORIO,
                            }}
                            disabled={
                                props.atributosPorEtapa?.filter(
                                    (atributo) =>
                                        atributo.DS_ATRIBUTO === "DT_TQ_CAT_SPU"
                                )[0]?.FL_APENAS_LEITURA
                            }
                        ></UnForm.Input>
                    )}
                </div>
            </div>
        </>
    );
}
